"use client";

import { useContext, useState } from "react";
import { StreamdownContext, type ControlsConfig, type CustomRendererProps } from "streamdown";
import { MermaidChart } from "@/components/lazy-heavy-components";
import { useTheme } from "@/hooks/use-theme";

export { normalizeMermaidSvgForPng, mermaidSvgToPngBlob } from "@/components/mermaid-export";

type MermaidControl = "copy" | "download" | "fullscreen" | "panZoom";
function hasMermaidControl(controls: ControlsConfig, control: MermaidControl): boolean {
  if (typeof controls === "boolean") return controls;
  const mermaid = controls.mermaid;
  if (mermaid === false) return false;
  if (mermaid === true || mermaid === undefined) return true;
  return mermaid[control] !== false;
}

let nextRenderId = 0;

/** Streamdown's custom renderer runs immediately, without its visibility gate. */
export function MessageMermaidRenderer({ code, isIncomplete }: CustomRendererProps) {
  const { controls, isAnimating } = useContext(StreamdownContext);
  const { resolvedTheme } = useTheme();
  const [renderId] = useState(() => `message-mermaid-${++nextRenderId}`);
  return (
    <MermaidChart
      source={code}
      theme={resolvedTheme}
      renderId={renderId}
      controls={{
        copy: hasMermaidControl(controls, "copy"),
        download: hasMermaidControl(controls, "download"),
        fullscreen: hasMermaidControl(controls, "fullscreen"),
        panZoom: hasMermaidControl(controls, "panZoom"),
      }}
      actionsDisabled={isAnimating}
      isIncomplete={isIncomplete}
    />
  );
}
